import { modelOptions, post, prop } from "@typegoose/typegoose";
import { addSchemaKeyHook, getDefaultSchemaOptions, SchemaBase, SchemaConstructorArgs } from "../schemaBase.js";

const SCHEMA_KEY = "DocumentRedirect" as const;

/**
 * This is simply for using our backend for redirects. Going to `verdi.ag/A/${resourceIdentifier}` will redirect you to
 * the destinationLink.
 */
@modelOptions({
    schemaOptions: {
        collection: "DocumentRedirects",
        timestamps: true,
        ...getDefaultSchemaOptions(SCHEMA_KEY),
        _id: true,
    },
})
@post<SchemaBase<DocumentRedirect>>(...addSchemaKeyHook(SCHEMA_KEY))
export class DocumentRedirect extends SchemaBase<DocumentRedirect> {
    static schemaKey = SCHEMA_KEY;
    readonly schemaKey = SCHEMA_KEY;

    @prop({ type: () => String, required: true })
    public destinationLink!: string;

    @prop({ type: () => String, required: true, unique: true })
    public resourceIdentifier!: string;

    static getters = {} as const satisfies Record<string, (self: DocumentRedirect) => any>;

    static utilities = {} as const satisfies Record<string, (...args: any) => any>;

    constructor(properties?: SchemaConstructorArgs<DocumentRedirect>) {
        super(properties);
        Object.assign(this, properties);
    }
}
